import InView             from './classes/Inview';
import Pluton             from './classes/Pluton';
import PageView           from './classes/pageView';
import Router             from './classes/Router';

class VegOut {
    constructor() {
        document.body.scrollTo(0, 0);
        //this.router = new Router();
        this.parts = new Pluton();
        this.pageview = new PageView();
        this.inview = InView;

    }
}

function isCompatible() {
    let compatibilty = true;
    if (!Array.from) compatibilty = false;
    if (!Array.prototype.includes) compatibilty = false;
    if (typeof window.CustomEvent !== "function" ) compatibilty = false;
    if (!window.fetch) compatibilty = false;
    if (!window.Promise) compatibilty = false;
    if(!('classList' in document.createElement('p'))) compatibilty = false;
    if (window.NodeList && !NodeList.prototype.forEach) compatibilty = false;

    if (
        !'IntersectionObserver' in window &&
        !'IntersectionObserverEntry' in window &&
        !'intersectionRatio' in window.IntersectionObserverEntry.prototype
    ) {
        compatibilty = false;
    }
    return compatibilty;

}

window.polyfillLoaded = () => {
    window.dispatchEvent(new CustomEvent('vegout-polyfillloaded'));
}

window.addEventListener("load", function(event) {
    if(window.polyfill || isCompatible()) window.VegOut = new VegOut();
    else window.addEventListener('vegout-polyfillloaded', () => { window.VegOut = new VegOut(); });
});
